// extracted by mini-css-extract-plugin
export default {"wrapper":"google-map__wrapper___2_lHZ","map":"google-map__map___2FaNl"};